import type { UserRelationship } from './user-relationship.type.ts';
export interface UserRelationshipExtension extends UserRelationship {}
export class UserRelationshipExtension {
  /**
   * Returns the company user ID from the jurisdiction's user_id
   * This matches the old role_views.company_id behavior
   */
  get companyUserId(): string | undefined {
    return this.jurisdiction?.user?.id ?? undefined;
  }
}

const Registration = {
  kind: 'object',
  name: 'user-relationship',
  features: UserRelationshipExtension,
};
export default Registration;
